/**
 * Callback for tracking network transfer progress.
 *
 * Receives current progress info (bytes done and total).
 *
 * @example
 * ```ts
 * const track: NetworkTrackingCallback = ({ done, total }) => {
 *   console.log(`${done}/${total} bytes`)
 * }
 * ```
 */
export type NetworkTrackingCallback = (info: {
  done: number
  total: number
}) => void

/**
 * Progress tracking configuration for network requests.
 *
 * Optional callbacks for monitoring upload and download progress.
 *
 * @example
 * ```ts
 * const progress: NetworkProgress = {
 *   download: ({ done, total }) => console.log(`Downloaded: ${done}/${total}`)
 * }
 * ```
 */
export type NetworkProgress = {
  download?: NetworkTrackingCallback
  upload?: NetworkTrackingCallback
}
